<button
  mat-icon-button
  matSuffix
  type="button"
  tabindex="-1"
  [disabled]="disabled"
  [attr.aria-label]="ariaLabel || text"
  (click)="$event.preventDefault(); $event.stopPropagation(); tooltip.toggle()"
  [matTooltip]="text"
  [matTooltipDisabled]="disabled"
  [matTooltipClass]="'universalTooltip ' + tooltipClass"
  #tooltip="matTooltip">
  <mat-icon *ngIf="!svgIcon">{{ icon }}</mat-icon>
  <mat-icon *ngIf="svgIcon" [svgIcon]="svgIcon"></mat-icon>
</button>
